import { gql } from '@apollo/client';

const OPERATION_AD_FIELDS = `
  ad {
    id
    legacyResourceId
    title
    path
    price
    photo {
      url
    }
  }
`;

const PAGE_INFO_FIELDS = `
  pageInfo {
    hasNextPage
    endCursor
  }
`;

export const GET_PAYMENTS_LIST = gql`
  query GetPaymentsList($first: Int = 15, $after: String) {
    currentUserPayments(first: $first, after: $after) {
      totalCount
      nodes {
        paymentLegacyId
        serviceId
        displayServiceName
        amount
        paymentMethod
        updatedAt
        originalPayment {
          displayServiceName
          paymentMethod
          rrn
          ad {
            legacyResourceId
          }
        }
        ${OPERATION_AD_FIELDS}
      }
      ${PAGE_INFO_FIELDS}
    }
  }
`;

export const GET_TRANSACTIONS_LIST = gql`
  query GetTransactionsList($first: Int = 15, $after: String) {
    currentUserTransactions(first: $first, after: $after) {
      totalCount
      nodes {
        paymentLegacyId
        serviceId
        displayServiceName
        amount
        paymentMethod
        createdAt
        ${OPERATION_AD_FIELDS}
      }
      ${PAGE_INFO_FIELDS}
    }
  }
`;

export const GET_PAID_ADS_TRANSACTIONS_LIST = gql`
  query GetPaidAdsTransactionsList($first: Int = 15, $after: String) {
    currentUserPaidAdsTransactions(first: $first, after: $after) {
      totalCount
      nodes {
        paidAdsTransactionLegacyId
        amount
        createdAt
        displayServiceName
        invoiceLegacyId
        ${OPERATION_AD_FIELDS}
      }
      ${PAGE_INFO_FIELDS}
    }
  }
`;
